<template lang="pug">
  .employers-details-wrapper
    h2 {{ id ? 'editar ': 'novo ' }} {{ $ws('employer')  }}

    Validate(v-model="name" :minLength="4")
      PTextField(label="razão social" name="social" v-focus)

    Validate(v-model="tradingName" :minLength="4" :required="false")
      PTextField(label="nome fantasia" name="nome")

    Validate(v-model="code" :minLength="1" :required="false")
      PTextField(label="código" name="code")

    .cnpj-cpf
      Validate(v-model="cnpj" :required="false" :customError="validCNPJ")
        PTextField(label="cnpj" name="cnpj" v-mask="'##.###.###/####-##'")

      Validate(v-model="cpf" :required="false" :customError="validCPF")
        PTextField(label="cpf" name="cpf" v-mask="'###.###.###-##'")

    .logo
      InputFile(:label="'logo do ' + $ws('employer')", v-model="fileToUpload" @input="exibirLogoSelecionada" ref="inputFile")

      .logo-pre-visualizacao
        .logo-do-empregador
          img.logo-do-empregador__imagem(v-if="logoUrl", :src="logoUrl")
          span(v-else) Não possui logo

    .button
      PButton(color="success" size="lg" @click="save" :loading="saving") salvar

</template>

<script>
import { useValidationsMixin } from 'src/common/validations'
import { validateCpf, validateCnpj } from 'src/utils'
import InputFile from 'src/common/inputs/InputFile'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'EmployersDetails',
  components: {InputFile},
  props: {
    id: {type: String, required: false}
  },
  mixins: [useValidationsMixin({deepCheck: true})],
  async created () {
    if (this.id) {
      const result = await this.$API.employer.get({
        id: this.id,
        fields: JSON.stringify(['cnpj', 'cpf', 'code', 'id', 'logo_url', 'name', 'trading_name'])
      })
      const [info] = result.data.success
      this.name = info.name
      this.code = info.code
      this.tradingName = info.tradingName
      this.cnpj = info.cnpj
      this.cpf = info.cpf
      this.logoUrl = info.logoUrl
    }
  },
  data () {
    return {
      saving: false,
      name: '',
      tradingName: '',
      cnpj: '',
      cpf: '',
      code: '',
      logoUrl: '',
      fileToUpload: null
    }
  },
  computed: {
    validCNPJ () {
      if (this.cpf && this.cnpj) {
        return 'cpf já informado'
      }
      if (this.cnpj && !validateCnpj(this.cnpj)) {
        return 'cnpj inválido'
      }
      return ''
    },
    validCPF () {
      if (this.cpf && this.cnpj) {
        return 'cnpj já informado'
      }

      if (this.cpf && !validateCpf(this.cpf)) {
        return 'cpf inválido'
      }
      return ''
    }
  },
  methods: {
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      this.saving = true

      try {
        let logoUrl = null
        try {
          if (this.$refs.inputFile.file) {
            const result = await this.$refs.inputFile.uploadToStorage('files_user', this.$refs.inputFile.file.name)
            logoUrl = result.body.success
          }
        } catch (e) {
          console.log('e')
        }

        await this.$API.employer.save(
          this.id ? {id: this.id} : undefined,
          {
            name: this.name,
            tradingName: this.tradingName,
            id: this.id,
            cnpj: this.cnpj,
            cpf: this.cpf,
            code: this.code,
            logoUrl
          }
        )
        setAmplitudeEvent('salva empregador', {})
        this.$swal({
          type: 'success',
          title: this.name,
          text: 'O ' + this.$ws('employer') + ' foi ' + (this.id ? 'alterado' : 'criado') + ' com sucesso'
        })
        this.$router.push('/employer/list')
      } catch (e) {
        console.error(e)
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possível salvar o ' + this.$ws('employer')
        })
      }
      this.saving = false
    },
    exibirLogoSelecionada (file) {
      if (file) {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        const vm = this
        fileReader.addEventListener('load', function () {
          vm.logoUrl = this.result
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
$primaryColor: var(--color-primary);

.employers-details-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 30px;

  h2 {
    grid-column: 1/3;
    text-align: center;
  }

  .cnpj-cpf {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
  }
  .button {
    grid-column: 1/3;
    justify-self: end;
  }

  .logo-do-empregador {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    & > * {
      border-radius: 1rem;
      padding: 1rem;
      border: 1px solid $primaryColor;
    }
    &__imagem {
      object-fit: contain;
      height: 100px;
      width: 100px;
    }
  }
}

.logo-pre-visualizacao {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
}
</style>
